<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useAdminFiltersStore } from '@/stores/adminFilters'

const adminFilters = useAdminFiltersStore()
const { showArchive } = storeToRefs(adminFilters)

const toggle = () => {
  showArchive.value = !showArchive.value
}
</script>

<template>
  <IconBtn
    :color="showArchive ? 'primary' : 'rgba(var(--v-theme-on-surface), var(--v-high-emphasis-opacity))'"
    @click="toggle"
  >
    <VIcon
      :icon="showArchive ? 'bx-archive-in' : 'bx-archive'"
      size="22"
    />
    <VTooltip
      activator="parent"
      open-delay="800"
      location="bottom"
      scroll-strategy="close"
    >
      <span>{{ showArchive ? 'Archief verbergen' : 'Archief tonen' }}</span>
    </VTooltip>
  </IconBtn>
</template>
